<script setup lang="ts">
import BaseButton from "@/core/components/base/BaseButton.vue";
import Icon from "@/core/components/icon/Icon.vue";

defineProps<{
    loading: boolean;
    actionLabel: string | null;
    disabled: boolean;
}>();
</script>

<template>
  <base-button primary :loading="loading" :disabled="loading || disabled">
    <icon
      :name="'mdi-printer'" color="white" :size="20"
      class="mr-2"
    />
    {{ actionLabel || 'Générer le rapport' }}
  </base-button>
</template>

<style scoped>
:deep(button[disabled]) {
    @apply !bg-gray-200;
}
</style>
